let Gender = {
    male: 0,
    female: 1,
    text: ["남성", "여성"],
    shortText: ["남", "여"]
}

export default Gender;